/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=User&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=User&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=58c14432&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c14432"]])

export default __exports__